import app from 'flarum/app';
import AbstractProcessingPage from './AbstractProcessingPage';
import LoadingIndicator from '../components/LoadingIndicator';
import ErrorPage from '../components/ErrorPage';
import PageContainer from '../components/PageContainer';

/* global m */

export default class AbstractFormPage extends AbstractProcessingPage {
    init() {
        super.init();

        const id = m.route.param('id');
        const preloadedForm = app.preloadedApiDocument();

        if (preloadedForm) {
            this.show(preloadedForm);
        } else {
            //TODO: check if form is already preloaded by slug
            const form = app.store.getById('formulaire-forms', id);

            if (form) {
                this.show(form);
            } else {
                app.store.find('formulaire/forms', id, {}, {
                    errorHandler: this.pageLoadErrorHandler.bind(this),
                }).then(form => {
                    this.show(form);
                    m.redraw();
                });
            }
        }
    }

    show(form) {
        this.form = form;
    }

    view() {
        if (this.errorPage) {
            return PageContainer.component({}, ErrorPage.component({
                error: this.errorPage,
            }));
        }

        if (!this.form) {
            return m('.container', LoadingIndicator.component({className: 'LoadingIndicator--block'}));
        }

        return this.content();
    }

    content() {
        // abstract
    }
}
